// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3hw2R","icon":"style_icon__3xJRp","title":"style_title__1VlBD","logo":"style_logo__11Lc4","logoContainer":"style_logoContainer__2oCur"};